import {
  Button,
  SequenceMenu,
  IconEllipsisHorizontal,
  GreyGrey60,
  Center
} from '@sequencehq/core-components'

export const CreditGrantKebabMenu = ({
  items
}: {
  items: React.ReactNode[]
}) => {
  return (
    <SequenceMenu
      width={226}
      alignment="bottom-right"
      items={items}
      menuButton={
        <Button variant="ghost" size="24px">
          <Center flexShrink="0">
            <IconEllipsisHorizontal color={GreyGrey60} />
          </Center>
        </Button>
      }
    />
  )
}
